import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const columnMatch: ThemeAPI['columnMatch'] = {
  root: {
    color: theme.colors.grey800,
    borderColor: theme.colors.grey200,
  },
  pageHeader: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    title: {
      fontSize: theme.fontSizes[300],
    },
    description: {
      fontSize: theme.fontSizes[200],
    },
  },
  icon: {
    color: theme.colors.iconPrimary,
  },
  matchingTitle: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    checkIcon: {
      color: theme.colors.iconPositive,
    },
    warningIcon: {
      color: theme.colors.warningBackgroundSolid,
    },
  },
  matchingPercent: {
    root: {
      backgroundColor: theme.colors.grey000White,
      color: theme.colors.grey600,
    },
    icon: {
      color: theme.colors.iconSecondary,
    },
  },
  notMatchingValue: {
    root: {
      backgroundColor: theme.colors.grey000White,
      color: theme.colors.iconPrimary,
    },
    icon: {
      color: theme.colors.warningBackgroundSolid,
    },
  },
  columnMatchHeader: {
    root: {
      backgroundColor: theme.colors.neutralBackground,
      borderColor: theme.colors.grey400,
      color: theme.colors.grey800,
    },
    icon: {
      stroke: theme.colors.iconPrimary,
    },
    dropdown: {
      scrollbar: {
        backgroundColor: theme.colors.grey600,
        navigatorColor: theme.colors.grey200,
      },
      search: {
        placeholder: theme.colors.grey800,
      },
      root: {
        backgroundColor: theme.colors.grey000White,
        color: theme.colors.grey800,
        borderColor: theme.colors.grey200,
      },
      selectedOption: {
        backgroundColor: theme.colors.grey200,
        ':hover': {
          backgroundColor: theme.colors.grey400,
        },
      },
      button: {
        placeholder: theme.colors.grey600,
        root: {
          backgroundColor: theme.colors.grey000White,
        },
        icon: {
          color: theme.colors.grey600,
        },
      },
      header: {
        backgroundColor: theme.colors.grey200,
        color: theme.colors.grey800,
      },
      option: {
        color: theme.colors.grey800,
        ':hover': {
          backgroundColor: theme.colors.grey200,
          color: theme.colors.grey800,
        },
      },
      badge: {
        root: {
          backgroundColor: theme.colors.grey300,
          color: theme.colors.iconPrimary,
          ':hover': {
            backgroundColor: theme.colors.grey300,
            color: theme.colors.iconPrimary,
          },
        },
        icon: {
          color: theme.colors.grey600,
        },
      },
      createNewOption: {
        root: {
          backgroundColor: theme.colors.grey200,
          color: theme.colors.grey800,
        },
        icon: {
          color: theme.colors.white,
        },
      },
    },
  },
  columnMatchValue: {
    root: {
      backgroundColor: theme.colors.grey000White,
      borderColor: theme.colors.grey400,
      color: theme.colors.grey800,
    },
    emptyValue: {
      color: theme.colors.grey600,
    },
    icon: {
      stroke: theme.colors.grey600,
    },
    scrollbar: {
      backgroundColor: theme.colors.grey600,
      navigatorColor: theme.colors.grey200,
    },
    dropdown: {
      scrollbar: {
        backgroundColor: theme.colors.grey600,
        navigatorColor: theme.colors.grey200,
      },
      search: {
        placeholder: theme.colors.grey800,
      },
      root: {
        backgroundColor: theme.colors.grey000White,
        color: theme.colors.grey800,
        borderColor: theme.colors.grey200,
      },
      selectedOption: {
        backgroundColor: theme.colors.grey200,
        ':hover': {
          backgroundColor: theme.colors.grey400,
        },
      },
      button: {
        placeholder: theme.colors.grey600,
        root: {
          backgroundColor: theme.colors.grey000White,
        },
        icon: {
          color: theme.colors.grey600,
        },
      },
      header: {
        backgroundColor: theme.colors.grey200,
        color: theme.colors.grey800,
      },
      option: {
        color: theme.colors.grey800,
        ':hover': {
          backgroundColor: theme.colors.grey200,
          color: theme.colors.grey800,
        },
      },
      badge: {
        root: {
          backgroundColor: theme.colors.grey300,
          color: theme.colors.iconPrimary,
          ':hover': {
            backgroundColor: theme.colors.grey300,
            color: theme.colors.iconPrimary,
          },
        },
        icon: {
          color: theme.colors.iconPrimary,
        },
      },
      createNewOption: {
        root: {
          backgroundColor: theme.colors.grey200,
          color: theme.colors.grey800,
        },
        icon: {
          color: theme.colors.white,
        },
      },
    },
  },
  requiredColumns: {
    title: {
      color: theme.colors.grey1000,
    },
    notMatchErrorIcon: {
      stroke: theme.colors.criticalBackgroundSolid,
    },
    notMatchError: {
      color: theme.colors.criticalBackgroundSolid,
    },
    hasMatchIcon: {
      stroke: theme.colors.iconPrimary,
    },
    hasMatch: {
      color: theme.colors.iconPrimary,
    },
    notMatch: {
      color: theme.colors.criticalBackgroundSolid,
    },
    notMatchIcon: {
      color: theme.colors.criticalBackgroundSolid,
    },
  },
  columnPopover: {
    backgroundColor: theme.colors.grey800,
    color: theme.colors.white,
  },
  joinBadge: {
    color: theme.colors.iconPrimary,
    border: theme.colors.grey300,
    backgroundColor: theme.colors.grey300,
    ':hover': {
      border: theme.colors.iconPrimary,
      backgroundColor: theme.colors.iconPrimary,
    },
  },
  sheetInfo: {
    color: theme.colors.iconPrimary,
    ':hover': {
      color: theme.colors.iconPrimary,
    },
  },
}
